/// <amd-module name="VSSUI/Components/DetailsPanel/DetailsPanel" />
import * as React from "react";
import { IMasterDetailsContextLayer } from "VSSUI/Context/MasterDetailsContext.Types";
import { MasterDetailsContext } from "VSSUI/MasterDetailsContext";
import { Observer } from "VSSUI/Observer";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { css } from "VSSUI/Util";
import { IDetailsPanelProps } from "./DetailsPanel.Props";

/**
 * A context-controlled detail area for the MasterDetails pattern
 * Render your own content instead of using this if you aren't using the context
 * and are using @see SingleLayerMasterPanel as your MasterPanel
 */
export const DetailsPanel: React.FunctionComponent<IDetailsPanelProps> = props => {
    const masterDetailsContext = React.useContext(MasterDetailsContext);

    return (
        <Surface background={SurfaceBackground.neutral}>
            <div className={css(props.className, "bolt-details-panel flex-row flex-grow")}>
                <Observer masterDetailsLayer={masterDetailsContext.getCurrentLayer()}>
                    {(observableProps: { masterDetailsLayer: IMasterDetailsContextLayer<any> }) => (
                        <Observer
                            selectedItem={observableProps.masterDetailsLayer.selectedMasterItem}
                            hideDetailsPanel={masterDetailsContext.hideDetailsPanel}
                        >
                            {(innerObservableProps: { selectedItem: any; hideDetailsPanel: boolean }) =>
                                !innerObservableProps.hideDetailsPanel &&
                                observableProps.masterDetailsLayer.detailsContent.renderContent(innerObservableProps.selectedItem)
                            }
                        </Observer>
                    )}
                </Observer>
            </div>
        </Surface>
    );
};
